export default "__VITE_ASSET__tIfiFZ2U__"